import React from 'react'

const HeaderSection = () => (
  <header className='header'>
    <h1 className='title'><i className="fas fa-user-friends"></i> 駄菓子屋に住むシェアハウス|淵野辺駅(相模原)の女性専用のシェアハウス情報</h1>
  </header>
)

export default HeaderSection


// WEBPACK FOOTER //
// ./src/HeaderSection.js